import { commitMutation, graphql } from 'react-relay';
import environment from '../../../environment';

const mutation = graphql`
    mutation calculatePositionsMutation($input: calculatePositionsInput!) {
        calculatePositions(input: $input) {
            code
            message
        }
    }
`;

/**
 *
 * @param {Object} data
 * @param {Number} callback
 */
function calculatePositions(data, callback){
    const variables = {
        input: {
            event_id: data.event_id,
            game_id: data.game_id,
        }
    }
    commitMutation(environment, {
        mutation,
        variables,
        onCompleted: (res, err) => {
            callback(res);
        },
        onError: err => console.error(err),
    })
}

export default calculatePositions;